import React from 'react'

import { StaticGoogleMap } from 'react-static-google-map'

import mapStyle from './map-styles'
import { usePageContext } from '@contexts/page-context'

const getStaticStyle = (styles) => {
  let style = ''

  const buildStaticStyle = (v, i, a) => {
    style = ''
    if (v?.stylers?.length > 0) {
      style +=
        (Object.prototype.hasOwnProperty.call(v, 'featureType') ? 'feature:' + v.featureType : 'feature:all') + '|'
      style +=
        (Object.prototype.hasOwnProperty.call(v, 'elementType') ? 'element:' + v.elementType : 'element:all') + '|'
      v.stylers.forEach(formatStaticStyle)
    }
    result.push('style=' + encodeURIComponent(style))
  }

  const formatStaticStyle = (val, i, a) => {
    const propertyname = Object.keys(val)[0]
    const propertyval = val[propertyname].toString().replace('#', '0x')
    style += propertyname + ':' + propertyval + '|'
  }

  const result = []
  styles.forEach(buildStaticStyle)

  return result.join('&')
}

// Lngs shifted slightly to accomodate input field
const locations = [
  // RD: Corbridge
  {
    lat: 54.974758,
    lng: -2.15671
  },
  // NY: Deal
  {
    lat: 51.222351,
    lng: 1.30165
  },
  // NH: Keswick
  {
    lat: 54.6003012,
    lng: -3.2366799
  },
  // MF: Upton Snodsbury
  {
    lat: 52.1785818,
    lng: -2.300972
  },
  // GA: Ingle Pingle
  {
    lat: 52.766573,
    lng: -1.311549
  },
  // TH: Hennessy Road
  {
    lat: 51.6257801,
    lng: -0.0454372
  }
]

const localPagesLocations = [
  {
    name: 'london',
    lat: 51.5094,
    lng: -0.187
  },
  {
    name: 'oxford',
    lat: 51.75854,
    lng: -1.29265
  },
  {
    name: 'aberdeen',
    lat: 57.14871,
    lng: -2.09781
  },
  {
    name: 'bristol',
    lat: 51.454514,
    lng: -2.64791
  },
  {
    name: 'edinburgh',
    lat: 55.953251,
    lng: -3.258267
  },
  {
    name: 'leeds',
    lat: 53.800755,
    lng: -1.609077
  },
  {
    name: 'belfast',
    lat: 54.60324,
    lng: -6.00093
  },
  {
    name: 'exeter',
    lat: 50.72071,
    lng: -3.59446
  },
  {
    name: 'norwich',
    lat: 52.6241,
    lng: 1.24186
  },
  {
    name: 'brighton',
    lat: 50.82266,
    lng: -0.17946
  },
  {
    name: 'cardiff',
    lat: 51.47908,
    lng: -3.22045
  },
  {
    name: 'glasgow',
    lat: 55.86011,
    lng: -4.29987
  },
  {
    name: 'manchester',
    lat: 53.48217,
    lng: -2.28401
  },
  {
    name: 'nottingham',
    lat: 52.95566,
    lng: -1.24201
  }
]

const MapContainer = (props) => {
  const { locality } = usePageContext()

  const randomPlace = () => Math.floor(Math.random() * locations.length)

  const currentLocation = localPagesLocations.find((city) => city.name === locality)
  const { lat, lng } = currentLocation || {}
  const place = locality ? { lat, lng } : locations[randomPlace()]

  const Blank = () => ''

  return (
    <div sx={props?.styles}>
      <StaticGoogleMap
        zoom={12}
        center={`${place.lat},${place.lng}`}
        size='600x368'
        sx={{ display: 'block' }}
        style={getStaticStyle(mapStyle.mapStyle)}
        apiKey={'AIzaSyCxnxTXn3CZII9foRak5zbMwsBWEvsmVeg'}
      >
        <Blank />
      </StaticGoogleMap>
    </div>
  )
}

export default MapContainer
